import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.slice.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "zxhj-details-list"
};
var _hoisted_2 = {
  class: "all_people"
};
var _hoisted_3 = {
  class: "icon_people"
};
var _hoisted_4 = {
  class: "right_people"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "target_top"
};
var _hoisted_7 = {
  class: "target_top-left"
};
var _hoisted_8 = {
  class: "name"
};
var _hoisted_9 = {
  class: "records"
};
var _hoisted_10 = {
  class: "icon_right"
};
var _hoisted_11 = {
  class: "target_bottom"
};
import { watch, onMounted, ref, onBeforeUnmount } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { evaPersonalOverview } from '@/api/index-ping';
export default {
  __name: 'index',
  props: {
    isPerson: {
      type: Boolean,
      default: false
    },
    periodId: {
      type: String,
      default: ''
    }
  },
  emits: ['detailJump'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var totalList = ref({
      targetVo: []
    }); // 获取数据
    var getData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var query, _yield$evaPersonalOve, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              query = {
                type: 'class',
                periodId: props.periodId
              };
              _context.p = 1;
              _context.n = 2;
              return evaPersonalOverview(query);
            case 2:
              _yield$evaPersonalOve = _context.v;
              data = _yield$evaPersonalOve.data;
              if (data && data.data) {
                totalList.value = data.data;
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.error(_t.message);
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function getData() {
        return _ref2.apply(this, arguments);
      };
    }();
    // 跳转详情
    var detailJump = function detailJump(data, isTeam) {
      emit('detailJump', data, isTeam);
    };
    watch(function () {
      return props.periodId;
    }, function (val) {
      if (val) {
        getData(val);
      }
    }, {
      immediate: true,
      deep: true
    });
    return function (_ctx, _cache) {
      var _totalList$value, _totalList$value3, _totalList$value4, _totalList$value5, _totalList$value6, _totalList$value7;
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass({
          'details-list_top': true,
          'details-second': !props.isPerson
        })
      }, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "acceptance"
      }, " 验收总览 ", -1)), (_totalList$value = totalList.value) !== null && _totalList$value !== void 0 && _totalList$value.targetVo && totalList.value.targetVo.length > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "details-list_total",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          var _totalList$value2;
          return detailJump((_totalList$value2 = totalList.value) === null || _totalList$value2 === void 0 ? void 0 : _totalList$value2.targetVo[0], false);
        })
      }, [_createElementVNode("div", _hoisted_2, "总记录 " + _toDisplayString((_totalList$value3 = totalList.value) === null || _totalList$value3 === void 0 ? void 0 : _totalList$value3.targetVo[0].records) + "条", 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, [_createVNode(_component_svg_icon, {
        name: "face-excellent",
        size: "16",
        class: "icon-face"
      }), _createTextVNode(" 总优秀数 " + _toDisplayString((_totalList$value4 = totalList.value) === null || _totalList$value4 === void 0 ? void 0 : _totalList$value4.targetVo[0].excellentCount), 1)]), _createElementVNode("span", null, [_createVNode(_component_svg_icon, {
        name: "face-qualified",
        size: "16",
        class: "icon-face"
      }), _createTextVNode(" 合格数 " + _toDisplayString((_totalList$value5 = totalList.value) === null || _totalList$value5 === void 0 ? void 0 : _totalList$value5.targetVo[0].passedCount), 1)]), _createElementVNode("span", null, [_createVNode(_component_svg_icon, {
        name: "face-unqualified",
        size: "16",
        class: "icon-face"
      }), _createTextVNode(" 不合格 " + _toDisplayString((_totalList$value6 = totalList.value) === null || _totalList$value6 === void 0 ? void 0 : _totalList$value6.targetVo[0].unqualifiedCount), 1)])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_svg_icon, {
        name: "arrow-right"
      })])])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass({
          list_second: true,
          list_second_person: !props.isPerson
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_totalList$value7 = totalList.value) === null || _totalList$value7 === void 0 ? void 0 : _totalList$value7.targetVo.slice(1), function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "second_target",
          onClick: function onClick($event) {
            return detailJump(item, false);
          }
        }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.secondNodeName), 1), _createElementVNode("span", _hoisted_9, "总记录" + _toDisplayString(item.records) + "条", 1)]), _createElementVNode("span", _hoisted_10, [_createVNode(_component_svg_icon, {
          name: "arrow-right"
        })])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, "总优秀数" + _toDisplayString(item.excellentCount), 1), _cache[1] || (_cache[1] = _createElementVNode("span", null, "|", -1)), _createElementVNode("div", null, "合格数" + _toDisplayString(item.passedCount), 1), _cache[2] || (_cache[2] = _createElementVNode("span", null, "|", -1)), _createElementVNode("div", null, "不合格数" + _toDisplayString(item.unqualifiedCount), 1)])], 8, _hoisted_5);
      }), 128))], 2)], 2)]);
    };
  }
};